import Axios from 'axios'

const base_url = process.env.REACT_APP_BASE_URL || 'http://localhost:5000'

export async function ToggleRescheduled(id: string): Promise<string> {
  const response = await Axios.post<string>(
    `${base_url}/api/schedule/${id}/toggle-reschedule`
  )
  return response.data
}
